import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'
import { get } from '@rails/request.js'

// Connects to data-controller="slim-remote"
export default class extends Controller {
  connect() {
    let placeholder = this.data.has('label') ? this.data.get('label') : 'Select'
    this.url = this.data.has('url') ? this.data.get('url') : '/agents/list.json'

    this.select = new SlimSelect({
      select: this.element,
      settings: {
        placeholderText: placeholder,
      },
      events: {
        search: (search, currentData) => {
          return new Promise((resolve, reject) => {
            if (search.length < 2) {
              return reject('Search must contain at least 2 characters')
            }

            const options = this.fetchCollection(this.url, search)
            resolve(options)
          })
        }
      }
    })
  }

  async fetchCollection(url, searchString) {
    const response = await get(url, {
      query: { q: searchString }
    })

    if (response.ok) {
      const body = await response.json
      // console.log(body)
      return body
    }
  }

  disconnect() {
    this.select.destroy()
    super.disconnect();
  }
}
